import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import AuthLinksTable from '@/components/authLink/AuthLinksTable.vue';
import { AuthItemAttributeRuleMapping } from '@/store/enums/authItemEnum';
import { AUTH_LINK_ADD, AUTH_LINK_LIST, AUTH_LINK_UPDATE } from '@/store/actions/authLink';
import { PLATFORM_LIST } from '@/store/actions/platforms';
import { AUTH_ITEM_LIST } from '@/store/actions/authItem';
var AuthLinkForm = /*#__PURE__*/function (_Vue) {
  function AuthLinkForm() {
    var _this;
    _classCallCheck(this, AuthLinkForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthLinkForm, [].concat(args));
    // -- Props
    _defineProperty(_this, "linkId", void 0);
    _defineProperty(_this, "toggleAuthLinkFormDialog", void 0);
    _defineProperty(_this, "visible", false);
    _defineProperty(_this, "additionalRuleOptions", []);
    // -- PROPERTY
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "authLinkForm", {
      platform: null,
      authenticationItem: null,
      authenticationAdditionalRuleType: AuthItemAttributeRuleMapping.NO_RULE,
      authenticationAdditionalRuleValue: ''
    });
    return _this;
  }
  _inherits(AuthLinkForm, _Vue);
  return _createClass(AuthLinkForm, [{
    key: "setAdditionalRuleOptions",
    value: function setAdditionalRuleOptions() {
      this.additionalRuleOptions = [{
        'label': this.$t('authentication_links_management.auth_link.form_modal.auth_rule_type_options.no_additional_rule').toString(),
        'value': AuthItemAttributeRuleMapping.NO_RULE
      }, {
        'label': this.$t('authentication_links_management.auth_link.form_modal.auth_rule_type_options.contain_value').toString(),
        'value': AuthItemAttributeRuleMapping.CONTAIN_VALUE
      }, {
        'label': this.$t('authentication_links_management.auth_link.form_modal.auth_rule_type_options.exact_value').toString(),
        'value': AuthItemAttributeRuleMapping.EXACT_VALUE
      }, {
        'label': this.$t('authentication_links_management.auth_link.form_modal.auth_rule_type_options.not_contain').toString(),
        'value': AuthItemAttributeRuleMapping.NOT_CONTAIN
      }, {
        'label': this.$t('authentication_links_management.auth_link.form_modal.auth_rule_type_options.exist').toString(),
        'value': AuthItemAttributeRuleMapping.EXIST
      }];
    }
  }, {
    key: "authItemAttributeRuleMapping",
    get: function get() {
      return AuthItemAttributeRuleMapping;
    }
  }, {
    key: "authItems",
    get: function get() {
      return Object.values(store.getters.authItems);
    }
  }, {
    key: "platforms",
    get: function get() {
      return Object.values(store.getters.platforms);
    }
    // -- VUE JS LIFECYCLE --
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;
      this.setAdditionalRuleOptions();
      if (this.isUpdateContext()) {
        store.dispatch(AUTH_LINK_LIST).then(function () {
          _this2.loading = false;
          var authLink = store.getters.authLink(_this2.linkId);
          _this2.authLinkForm.platform = authLink.platform.platformID;
          _this2.authLinkForm.authenticationItem = authLink.authItem.authItemID;
          _this2.authLinkForm.authenticationAdditionalRuleType = authLink.ruleType;
          _this2.authLinkForm.authenticationAdditionalRuleValue = authLink.valueMap;
        }).catch(function (err) {
          _this2.loading = false;
          _this2.errorMsg = err;
        });
      }
      store.dispatch(PLATFORM_LIST).then(function () {
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
      store.dispatch(AUTH_ITEM_LIST).then(function () {
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
    // -- CUSTOM FUNCTIONS --
    /**
     * Create the configured link
     */
  }, {
    key: "addLink",
    value: function addLink() {
      var _this3 = this;
      this.loading = true;
      var actionCreateOrUpdateLink = this.isUpdateContext() ? AUTH_LINK_UPDATE : AUTH_LINK_ADD;
      store.dispatch(actionCreateOrUpdateLink, {
        platformID: this.authLinkForm.platform,
        authItemID: this.authLinkForm.authenticationItem,
        additionalRuleType: this.authLinkForm.authenticationAdditionalRuleType,
        additionalRuleValue: this.authLinkForm.authenticationAdditionalRuleValue
      }).then(function () {
        return _this3.onDialogClose();
      }).catch(function (err) {
        return _this3.errorMsg = err;
      }).finally(function () {
        return _this3.loading = false;
      });
    }
    /**
     * Define if we are updating a link or creating one
     * @return boolean true if we are in a Update context, false otherwise
     */
  }, {
    key: "isUpdateContext",
    value: function isUpdateContext() {
      return !!this.linkId;
    }
  }, {
    key: "updateSelectedAuthLinkPlatform",
    value: function updateSelectedAuthLinkPlatform(value) {
      this.authLinkForm.platform = value;
    }
  }, {
    key: "updateSelectedAuthItem",
    value: function updateSelectedAuthItem(value) {
      this.authLinkForm.authenticationItem = value;
    }
  }, {
    key: "updateSelectedAuthAdditionalRuleType",
    value: function updateSelectedAuthAdditionalRuleType(value) {
      this.authLinkForm.authenticationAdditionalRuleType = value;
      if ([AuthItemAttributeRuleMapping.NO_RULE, AuthItemAttributeRuleMapping.EXIST].includes(this.authLinkForm.authenticationAdditionalRuleType)) {
        this.authLinkForm.authenticationAdditionalRuleValue = '';
      }
    }
  }, {
    key: "updateSelectedAuthAdditionalRuleValue",
    value: function updateSelectedAuthAdditionalRuleValue(value) {
      this.authLinkForm.authenticationAdditionalRuleValue = value;
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      return this.authLinkForm.platform !== null && this.authLinkForm.authenticationItem !== null && ([AuthItemAttributeRuleMapping.NO_RULE, AuthItemAttributeRuleMapping.EXIST].includes(this.authLinkForm.authenticationAdditionalRuleType) || !!this.authLinkForm.authenticationAdditionalRuleValue);
    }
  }, {
    key: "onDialogClose",
    value: function onDialogClose() {
      this.visible = false;
      this.$emit("dialogClose");
    }
  }]);
}(Vue);
__decorate([Prop()], AuthLinkForm.prototype, "linkId", void 0);
__decorate([Prop({
  default: false
})], AuthLinkForm.prototype, "toggleAuthLinkFormDialog", void 0);
AuthLinkForm = __decorate([Options({
  components: {
    AuthLinksTable: AuthLinksTable,
    MainTitle: MainTitle
  },
  watch: {
    toggleAuthLinkFormDialog: function toggleAuthLinkFormDialog() {
      this.visible = this.toggleAuthLinkFormDialog;
    }
  }
})], AuthLinkForm);
export default AuthLinkForm;